import { render, staticRenderFns } from "./Instrumentsview.vue?vue&type=template&id=e793878a&scoped=true"
import script from "./Instrumentsview.vue?vue&type=script&lang=js"
export * from "./Instrumentsview.vue?vue&type=script&lang=js"
import style0 from "./Instrumentsview.vue?vue&type=style&index=0&id=e793878a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e793878a",
  null
  
)

export default component.exports